<template>

  <div class="content">
    <div class="container-fluid">
      <card>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center"><i class="fas fa-exclamation-triangle"></i> Hata</h4>
          <ul class="mb-0">
            <li v-for="e in errors">
              {{e}}
            </li>
          </ul>
        </b-alert>


        <div class="row">
          <div class="col-12 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" v-bind:class="{'is-invalid' : errors.includes('E-Posta Formatı Doğru Değil')}" id="basic-addon1">E-Posta</span>
            </div>
            <input type="text" class="form-control" placeholder="E-Posta" aria-label="E-Posta" v-bind:class="{'is-invalid' : errors.includes('E-Posta Formatı Doğru Değil')}" v-model="subscriber.email" id="name" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill float-md-right" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  export default {
    data: function () {
      return {
        subscriber:{
          email:null,
          is_subscribed: 1
        },
        errors:[],
        // end of post data
        options: {
          language_url: '/static/plugins/tinymce-lang/tr.js',
          height: 300
        }
      }
    },
    components: {
      Checkbox,
      Card
    },
    methods: {
      checkForm:function() {
        this.errors = [];
        if(!this.subscriber.email) {this.errors.push("E-Posta Alanını Doldurmanız Gerek")};
        if(!this.validEmail(this.subscriber.email)) {this.errors.push("E-Posta Formatı Doğru Değil")}
        if(!this.errors.length) {
          this.saveEmail()
        }
      },
      saveEmail: function() {
        this.toggleLoader()
        this.$http.post('/api/newsletter/add', this.subscriber).then(
          response => {
            this.notifier('top', 'right', 'success', 'Başarılı')
            this.$router.push('/newsletter')
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      validEmail:function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
    }
  }
</script>
<style>
.input-group-text.is-valid{
  border-color: #28a745 !important;
}
.input-group-text{
  transition: 300ms;
}
.input-group-text.is-invalid{
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color:#fff;
}
.form-check-label{
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text{
  background-color: #e9ecef;
  border: 1px solid #ced4da; 
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/NewsletterModules/NewSubscriber.vue